/**
 * CalculatorDetails — «Расчёт» body for a calculator: formula lines +
 * constants. Moved out of ServiceManagementPage.tsx (KAN-157 god-component
 * split).
 *
 * The «Входные параметры» and «Выход» sub-blocks were moved OUT into the
 * unified inputs/output sections (TASK-197), so each card shows exactly one
 * «Входные параметры»/«Выходные данные».
 */
import type { Chain, Service } from '@/services/api/services';
import { extractFormulaLines } from '@/utils/serviceFormula';
import { CalcEmptyNotice } from './CalcEmptyNotice';

export function CalculatorDetails({ service }: { service: Service }): JSX.Element {
  const chains = service.chains || [];

  if (chains.length === 0) {
    return <CalcEmptyNotice testid="calculator-empty" message="Нет цепочек вычислений" />;
  }

  return (
    <div className="space-y-6">
      {chains.map((chain: Chain) => {
        const formulaLines = extractFormulaLines(chain);

        return (
          <div key={chain.id} className="space-y-3">
            {/* Формула */}
            {formulaLines.length > 0 && (
              <div>
                <div className="text-xs font-medium text-gray-500 mb-1">Формула</div>
                <div className="rounded-md border bg-gray-50 px-3 py-2 space-y-3">
                  {formulaLines.map(line => (
                    <code key={line.key} className="block text-sm text-gray-800 font-mono whitespace-pre-wrap break-words">
                      {line.out ? `${line.out} = ` : ''}
                      {line.formula}
                    </code>
                  ))}
                </div>
              </div>
            )}

            {/* Константы */}
            {chain.constants && Object.keys(chain.constants).length > 0 && (
              <div>
                <div className="text-xs font-medium text-gray-500 mb-1">Константы</div>
                <ul className="text-sm text-gray-700 space-y-0.5">
                  {Object.entries(chain.constants).map(([key, value]) => (
                    <li key={key}>
                      {key} = {String(value)}
                    </li>
                  ))}
                </ul>
              </div>
            )}
          </div>
        );
      })}
    </div>
  );
}
